import React, { useState, useEffect, useRef } from "react";
import InsertRecordForm from "./InsertRecordForm";
import GroupTable from "./GroupTable";
import SpaceTable from "./SpaceTable";
import EditRecordForm from "./EditRecordForm";
import ReconnectingWebSocket from "reconnectingwebsocket";
import { useAuthUser } from "use-eazy-auth";
import classNames from "classnames";

function Planner() {
  const [state, setState] = useState([]);
  const { token } = useAuthUser();
  const [week, setWeek] = useState("1a settimana");
  const [editing, setEditing] = useState({
    group: null,
    space: null,
    week: "1a settimana",
    day: "Lunedì",
    slice: "pre",
    activity: "",
  });
  const wsRef = useRef(null);
  const [prePostMode, setPrePostMode] = useState("both");

  useEffect(() => {
    wsRef.current = new ReconnectingWebSocket(
      process.env.NODE_ENV === "production"
        ? "wss://" + window.location.host + "/ws"
        : "ws://localhost:8999/ws"
    );
    wsRef.current.addEventListener("message", (msg) => {
      setState(JSON.parse(msg.data));
    });
    wsRef.current.addEventListener("open", () => {
      wsRef.current.send(JSON.stringify({ type: "login", token }));
    });
  }, [token]);

  return (
    <div className="app px-3">
      {token && (
        <>
          <h1 style={{ marginTop: 10, marginBottom: 10 }}>
            Pianificazione CRE - Oratorio Brembate
          </h1>
          <blockquote
            style={{
              marginTop: 10,
              marginBottom: 10,
              marginLeft: 10,
              borderLeft: "3px solid #cccccc",
              paddingLeft: 10,
              paddingTop: 3,
              paddingBottom: 3,
            }}
          >
            L'organigramma <i>(Silvia Gaspani)</i>
          </blockquote>
          <div className="insert-record">
            {!editing && (
              <InsertRecordForm
                state={state}
                onCommit={(value) => setState((prev) => [...prev, value])}
              />
            )}
            {editing && (
              <EditRecordForm
                key={`${editing.group}-${editing.week}-${editing.day}-${editing.slice}`}
                state={state}
                init={editing}
                onCommit={(value) => {
                  wsRef.current.send(JSON.stringify(value));
                  setEditing(value);
                }}
                onAbort={() => setEditing(null)}
              />
            )}
            <div style={{ marginTop: 15 }} className="btn-group">
              <button
                className={classNames("btn btn-sm", {
                  "btn-secondary": week === "1a settimana",
                  "btn-light": week !== "1a settimana",
                })}
                type="button"
                onClick={() => setWeek("1a settimana")}
              >
                {"1a settimana"}
              </button>
              <button
                className={classNames("btn btn-sm", {
                  "btn-secondary": week === "2a settimana",
                  "btn-light": week !== "2a settimana",
                })}
                type="button"
                onClick={() => setWeek("2a settimana")}
              >
                {"2a settimana"}
              </button>
              <button
                className={classNames("btn btn-sm", {
                  "btn-secondary": week === "3a settimana",
                  "btn-light": week !== "3a settimana",
                })}
                type="button"
                onClick={() => setWeek("3a settimana")}
              >
                {"3a settimana"}
              </button>
              <button
                className={classNames("btn btn-sm", {
                  "btn-secondary": week === "4a settimana",
                  "btn-light": week !== "4a settimana",
                })}
                type="button"
                onClick={() => setWeek("4a settimana")}
              >
                {"4a settimana"}
              </button>
              {/* <button
                className={classNames("btn btn-sm", {
                  "btn-secondary": week === "5a settimana",
                  "btn-light": week !== "5a settimana",
                })}
                type="button"
                onClick={() => setWeek("5a settimana")}
              >
                {"5a settimana"}
              </button> */}
            </div>
            <br />
            <div style={{ marginTop: 15 }} className="btn-group">
              <button
                className={classNames("btn btn-sm", {
                  "btn-secondary": prePostMode === "pre",
                  "btn-light": prePostMode !== "pre",
                })}
                type="button"
                onClick={() => setPrePostMode("pre")}
              >
                {"Pre"}
              </button>
              <button
                className={classNames("btn btn-sm", {
                  "btn-secondary": prePostMode === "post",
                  "btn-light": prePostMode !== "post",
                })}
                type="button"
                onClick={() => setPrePostMode("post")}
              >
                {"Post"}
              </button>
              <button
                className={classNames("btn btn-sm", {
                  "btn-secondary": prePostMode === "both",
                  "btn-light": prePostMode !== "both",
                })}
                type="button"
                onClick={() => setPrePostMode("both")}
              >
                {"Pre + Post"}
              </button>
            </div>
            <GroupTable
              state={state}
              week={week}
              setEditing={setEditing}
              prePostMode={prePostMode}
            />
            <SpaceTable
              state={state}
              week={week}
              setEditing={setEditing}
              prePostMode={prePostMode}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default Planner;
